import { ProviderCredentialListItem } from '../../../integrated-client/models/';

export type ProviderCredentialList = Array<ProviderCredentialListItem>;

export class ResultsData {

  items: ProviderCredentialList
  showMore: boolean

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}
